/** @format */

import { Component, OnInit } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { take } from "rxjs/operators";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { BookingDataService } from "../../../services/booking-data.service";
import { cancelBooking, cancelBookingRequest } from "../booking-form/booking-generators";
import { ModalRef } from "mis-design-system/mis-modal";
import { WidgetService } from "../../../services/widget.service";
import { LoaderService } from "../../../services/loader.service";
import { ApiService } from "../../../services/api.service";
import { ToastService } from "mis-crystal-design-system/toast";
import { Item } from "mis-design-system/select-v2";
import { getAdditionalBookings, getTypeOfTransport, messageForCancellation } from "../../../functions/booking-utils.functions";
import { TranslateService } from "@ngx-translate/core";
import { ConfigurationService } from "../../../services/configuration.service";

@Component({
  selector: "mis-employee-web-exp-delete-confirmation",
  templateUrl: "./delete-confirmation.component.html",
  styleUrls: ["./delete-confirmation.component.scss"]
})
export class DeleteConfirmationComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  booking = this.bookingSvc.formConfiguration.data;
  configs = this.bookingSvc.formConfiguration.userConfigs;
  deleteOptions = [
    {
      name: "Entire Booking",
      id: 0,
      startTime: this.bookingSvc.formConfiguration.data.startTime,
      endTime: this.bookingSvc.formConfiguration.data.endTime
    }
  ];
  deleteRecurrenceOptions: Item[] = [
    {
      label: "This Booking",
      value: "1"
    },
    {
      label: "This and following bookings",
      value: "2"
    }
  ];
  selectedRecurrenceOption = [];
  selectedRecurrenceDelete = { label: "", value: "" };
  selection = this.deleteOptions[0];
  deleteMessage = "";
  constructor(
    private bookingSvc: BookingDataService,
    public modalRef: ModalRef,
    private widgetSvc: WidgetService,
    private loader: LoaderService,
    private apiService: ApiService,
    private toast: ToastService,
    private translateSvc: TranslateService,
    private configService: ConfigurationService
  ) {}

  ngOnInit(): void {
    const booking = this.bookingSvc.formConfiguration.data as NsEmpWebExpData.IBookingDetailDTOS;
    if (getTypeOfTransport(booking, "LOGIN")) {
      this.deleteOptions.push({
        name: "Check-in Transport",
        id: 1,
        startTime: null,
        endTime: null
      });
    }
    if (getTypeOfTransport(booking, "LOGOUT")) {
      this.deleteOptions.push({
        name: "Check-out Transport",
        id: 2,
        startTime: null,
        endTime: null
      });
    }
    if (getAdditionalBookings(booking, ["PARKING_TWO", "PARKING_FOUR"])) {
      this.deleteOptions.push({
        name: "Only Parking",
        id: 3,
        startTime: this.bookingSvc.formConfiguration.data.startTime,
        endTime: this.bookingSvc.formConfiguration.data.endTime
      });
    }
    if (getAdditionalBookings(booking, ["MEALS"])) {
      this.deleteOptions.push({
        name: "Only Meal",
        id: 4,
        startTime: null,
        endTime: null
      });
    }
  }
  onRecurreceOptionChange(data) {
    this.selectedRecurrenceDelete = {
      label: data.label,
      value: data.value
    };
  }
  confirmDelete(): void {
    let req = [];
    let recurrenceId = null;
    if (this.selectedRecurrenceDelete.value.length > 0) {
      recurrenceId = this.selectedRecurrenceDelete.value === "1" ? null : this.booking.recurrenceId;
    }
    req = this.checkForSelectedOption(recurrenceId);
    this.requestCancelBookings(req);
  }

  checkForSelectedOption(recurrenceId) {
    let channel = this.configService.isTeamsApp ? "MS_TEAMS" : "EMPLOYEE_WEB";
    let req = [];
    switch (this.selection.id) {
      case 0:
        req = cancelBooking(this.booking, recurrenceId, [this.booking.premiseType], channel);
        this.deleteMessage = messageForCancellation("Booking");
        break;
      case 1:
        req = cancelBooking(getTypeOfTransport(this.booking, "LOGIN"), recurrenceId, ["LOGIN_TRANSPORT"], channel);
        this.deleteMessage = messageForCancellation("Login Transport");
        break;
      case 2:
        req = cancelBooking(getTypeOfTransport(this.booking, "LOGOUT"), recurrenceId, ["LOGOUT_TRANSPORT"], channel);
        this.deleteMessage = messageForCancellation("Logout Transport");
        break;
      case 3:
        req = cancelBooking(getAdditionalBookings(this.booking, ["PARKING_TWO", "PARKING_FOUR"])[0], recurrenceId, null, channel);
        this.deleteMessage = messageForCancellation("Parking");
        break;
      case 4:
        req = cancelBooking(getAdditionalBookings(this.booking, ["MEALS"])[0], recurrenceId, null, channel);
        this.deleteMessage = messageForCancellation("Meal");
        break;
    }
    return req;
  }

  requestCancelBookings(bookings: NsEmpWebExpData.IBookingCancelRequest[]): void {
    this.translateSvc.get("This may take a few seconds...").subscribe(response => {
      if (response) {
        this.loader.show(this.translateSvc.instant("This may take a few seconds..."));
      } else {
        this.loader.show(this.translateSvc.instant("This may take a few seconds..."));
      }
    });
    this.apiService.cancelBookings(bookings).subscribe(res => {
      res.bookingCancelled ? this.toast.displayMsg(this.deleteMessage) : this.toast.displayMsg(res.message);
      this.loader.hide();
      this.widgetSvc.refreshWidgets("BOOKINGS");
      this.modalRef.close();
    });
  }
}
